import { IUpdateGeneralParameterPayload } from '@interfaces/configuration.interface';
import { api } from '@services/api';
import { IGenpar, IGenparAPI, setGenpar } from '@store/slices/genpar.slice';
import { encryptPayload } from '@utils/security';
import { handleError } from '../utils/api-error-handling';

export const generalParameterApi = api
  .enhanceEndpoints({ addTagTypes: ['GENPAR'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getListGeneralParams: builder.query({
        query: () => 'lists/general-parameters',
        providesTags: ['GENPAR'],
        async onQueryStarted(_, { queryFulfilled, dispatch }) {
          try {
            const { data } = await queryFulfilled;

            const items: IGenpar[] = data.data.map(
              (item: { parameter: IGenpar }) => ({
                descr: item.parameter.descr,
                value: item.parameter.value,
                descrLong: item.parameter.descrLong,
                parameter: item.parameter.parameter,
                subModule: item.parameter.subModule,
              }),
            );

            dispatch(setGenpar(items));
          } catch (err) {
            console.error('Error caching genpar:', err);
          }
        },
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: IGenparAPI) => {
          return response;
        },
        forceRefetch() {
          return true;
        },
      }),
      getGeneralParameterByGroup: builder.query({
        query: (groupings: String) => ({
          url: `lists/general-parameters/${groupings}`,
          method: 'GET',
        }),
        providesTags: ['GENPAR'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: any) => {
          return response;
        },
        forceRefetch() {
          return true;
        },
      }),
      updateGeneralParameter: builder.mutation({
        query: (payload: IUpdateGeneralParameterPayload) => ({
          url: 'configuration/general-parameters',
          method: 'PATCH',
          body: encryptPayload(payload),
        }),
        async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
          try {
            const { data } = await queryFulfilled;
            if (data) {
              dispatch(generalParameterApi.util.invalidateTags(['GENPAR']));
            }
          } catch (error) {}
        },
        transformErrorResponse: async (baseQueryReturnValue: any) => {
          return handleError(baseQueryReturnValue);
        },
      }),
    }),
  });

export const {
  useGetListGeneralParamsQuery,
  useLazyGetListGeneralParamsQuery,
  useLazyGetGeneralParameterByGroupQuery,
  useGetGeneralParameterByGroupQuery,
  useUpdateGeneralParameterMutation,
} = generalParameterApi;
